import React, { useState } from "react";
import { Button, Spinner } from "flowbite-react";
import toast from "react-hot-toast";
import { Eye, EyeOff } from "lucide-react";
import TopHeader from "./TopHeader";
import Backend from "../../../../Backend/Backend";
import useSize from "../../../../Utils/useSize/useSize";

const backend = await new Backend().init();

export default function CPassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async () => {
    if (!oldPassword.trim()) return toast.error("Enter old password");
    if (!newPassword.trim()) return toast.error("Enter new password");
    if (!confirmPassword.trim()) return toast.error("Enter confirm password");
    if (newPassword !== confirmPassword)
      return toast.error("Passwords do not match!");

    try {
      setLoading(true);
      const data = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        server: localStorage.getItem("server"),
        username: localStorage.getItem("username"),
        oldpassword: oldPassword,
        cpassword: newPassword,
      };

      const response = await backend.cpassword(data);
      setLoading(false);

      if (response.error === "False") {
        toast.success(response.message);
        window.LogOut();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong!");
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col">
      <div>
        <TopHeader />
      </div>
      <div className="bg-[var(--background)] justify-between items-center p-6 md:p-8">
        {/* Old Password */}
        <div className="mb-4">
          <label
            htmlFor="oldpassword"
            className="block text-sm font-medium mb-1 text-[var(--text)] "
          >
            Old Password
          </label>
          <input
            type="password"
            id="oldpassword"
            className="w-full bg-[var(--background)] rounded-lg border-2 border-[var(--hover)] px-3 py-2.5 text-[var(--text)] focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition"
            placeholder="Enter your old password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </div>

        {/* New Password */}
        <div className="mb-4 relative">
          <label
            htmlFor="newpassword"
            className="block text-sm font-medium mb-1 text-[var(--text)] "
          >
            New Password
          </label>
          <div className="relative">
            <input
              type={showNew ? "text" : "password"}
              id="newpassword"
              className="w-full bg-[var(--background)] rounded-lg border-2 border-[var(--hover)] text-[var(--text)] px-3 py-2.5  focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition pr-10"
              placeholder="Enter your new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowNew(!showNew)}
              className="absolute right-3 top-2.5 text-[var(--text)]"
            >
              {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Confirm Password */}
        <div className="mb-6 relative">
          <label
            htmlFor="confirmpassword"
            className="block text-sm font-medium mb-1 text-[var(--text)]"
          >
            Confirm Password
          </label>
          <div className="relative">
            <input
              type={showConfirm ? "text" : "password"}
              id="confirmpassword"
              className="w-full bg-[var(--background)] rounded-lg border-2 border-[var(--hover)] text-[var(--text)] px-3 py-2.5 focus:ring-[var(--primary)] focus:border-[var(--primary)] outline-none transition pr-10"
              placeholder="Re-enter new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowConfirm(!showConfirm)}
              className="absolute right-3 top-2.5 text-[var(--text)] "
            >
              {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Submit Button */}
        <div
          onClick={!loading ? handleSubmit : null}
          disabled={loading}
          className="w-full text-white text-center py-2.5 font-semibold bg-[var(--primary)] hover:bg-[var(--primary)] focus:ring-0 focus:outline-none transition-all rounded-lg py-1"
        >
          {loading ? (
            <div className="flex items-center justify-center gap-2">
              <Spinner size="sm" /> Processing...
            </div>
          ) : (
            "Update Password"
          )}
        </div>
      </div>
    </div>
  );
}
